import { AsyncPipe, NgClass, NgFor, NgIf } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ModalComponent, SdvorButtonComponent, SdvorCheckboxComponent } from '@sdvor/shared/ui';
import { SdvorRadioComponent } from '@sdvor/shared/ui/v2';
import { IconModule, SpinnerComponent } from '@spartacus/storefront';
import { PaymentScheduleComponent } from '../payment-schedule/payment-schedule.component';
import { PrePaymentModule } from '../prepayment/prepayment.module';
import { SdvorCheckoutPaymentChooseListComponent } from './checkout-payment-choose-list/checkout-payment-choose-list.component';
import { SdvorCheckoutPaymentComponent } from './checkout-payment.component';

@NgModule({
  imports: [
    NgClass,
    NgIf,
    AsyncPipe,
    NgFor,
    SpinnerComponent,
    SdvorButtonComponent,
    IconModule,
    PrePaymentModule,
    SdvorCheckboxComponent,
    ReactiveFormsModule,
    ModalComponent,
    SdvorRadioComponent,
    FormsModule,
    PaymentScheduleComponent,
  ],
  declarations: [SdvorCheckoutPaymentComponent, SdvorCheckoutPaymentChooseListComponent],
  exports: [SdvorCheckoutPaymentComponent],
})
export class SdvorCheckoutPaymentModule {}
